// extracted by mini-css-extract-plugin
export default {"label":"NewCaseForm1_label__PYDUr"};